<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>服务工单流转</span>
          </div>
          <el-table
            :data="housekeepingServPoolUserManageInfo.housekeepingServPoolUsers"
            border
            style="width: 100%">
            <el-table-column
              prop="staffName"
              label="当前处理员工"
              align="center">
            </el-table-column>
            <el-table-column
              prop="preStaffName"
              label="上一节点处理员工"
              align="center">
            </el-table-column>
            <el-table-column
              prop="startTime"
              label="工单开始时间"
              align="center">
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="工单结束时间"
              align="center">
            </el-table-column>
            <el-table-column
              prop="poolEvent"
              label="事件"
              align="center">
            </el-table-column>
            <el-table-column
              prop="state"
              label="员工处理状态"
              align="center">
            </el-table-column>
            <el-table-column
              prop="context"
              label="处理说明"
              align="center">
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="housekeepingServPoolUserManageInfo.conditions.page"
            :page-size="housekeepingServPoolUserManageInfo.conditions.row"
            layout="total, prev, pager, next, jumper"
            :total="housekeepingServPoolUserManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryHousekeepingServPool } from '@/api/housekeeping/housekeepingServPoolUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'HousekeepingServPoolUserManage',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      housekeepingServPoolUserManageInfo: {
        housekeepingServPoolUsers: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.housekeepingServPoolUserManageInfo.conditions.shopId = getShopId()
    this._listHousekeepingServPoolsUser(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    handleCurrentChange(val) {
      this._listHousekeepingServPoolsUser(val, this.DEFAULT_ROWS)
    },
    _listHousekeepingServPoolsUser(_page, _rows) {
      this.housekeepingServPoolUserManageInfo.conditions.page = _page
      this.housekeepingServPoolUserManageInfo.conditions.row = _rows
      
      queryHousekeepingServPool(this.housekeepingServPoolUserManageInfo.conditions)
        .then(response => {
          const data = response.data
          this.housekeepingServPoolUserManageInfo.total = data.total
          this.housekeepingServPoolUserManageInfo.records = data.records
          this.housekeepingServPoolUserManageInfo.housekeepingServPoolUsers = data.data
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    _queryHousekeepingServPoolMethod() {
      console.log('moreCondition:', this.housekeepingServPoolUserManageInfo.moreCondition)
      this._listHousekeepingServPoolsUser(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>